export const teamBillingSelector = ({ state, teamId }) => {
  return state.entities.teamBilling[teamId];
};
